﻿import React, { useContext } from 'react';
import { BookingFlowContext } from '../BookingFlowContext'

export const Heading = (props) => {
  const { bookingFlowContext } = useContext(BookingFlowContext);
  let headingText = '';

  if (props.text)
    headingText = props.text;
  else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.orderOverview.index)
    headingText = bookingFlowContext.localization.orderOverview.heading;
  else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.orderConfirmation.index)
    headingText = '';
  else
    headingText = bookingFlowContext.facility.name;

  if (headingText.length === 0) {
    return null;
	}

  return (
    <h1 className="bookingflowpage__heading">{headingText}</h1>
  )
}
